module.exports = __webpack_public_path__ + "media/images/search_background-f884056ff7778694fad8e7baa4bfa7a3.jpg";